import React, { useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { Button } from 'primereact/button'
import { routes } from '../../constants'
import storage from '../../services/stoage.service'
import { messageActions } from '../../store/message'
import { AgendarRelatorioDialog } from './AgendarRelatorioDialog'
import { podeAgendar } from './agendamentoRelatorio.utils'
import { getRelatorioAgendavel } from './relatoriosAgendaveis'
import { textoAgendamento } from './textos'

const mapDispatchToProps = (dispatch) => ({
  mostrarSucesso: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'success')),
})

/**
 * Botao "Agendar" das telas fixas de relatorio, com o dialogo de agendamento. Vai ao lado do "Visualizar" da tela.
 * Nao aparece para quem nao acessa "Relatorios agendados" nem para path sem cadastro em relatoriosAgendaveis.
 *
 * Props:
 * - path: o relatorio em relatoriosAgendaveis (e em TelasFixasAgendaveis, no back), ex.: 'falecidos'
 * - record: o registro da tela; os filtros do agendamento saem dele, como no "Visualizar"
 */
const AgendarTelaFixaBase = ({ path, record, mostrarSucesso }) => {
  const [visivel, setVisivel] = useState(false)
  const pode = useMemo(() => podeAgendar(storage.getMenus(), routes.PATH_AGENDAMENTOS_RELATORIO), [])
  const agendavel = useMemo(() => getRelatorioAgendavel(path), [path])
  if (!pode || !agendavel || !agendavel.filtrosDaTela) {
    return null
  }
  return (
    <React.Fragment>
      <Button
        label={textoAgendamento('agendar')}
        icon="pi pi-clock"
        className="p-button-secondary"
        style={{ marginLeft: '.25em' }}
        onClick={() => setVisivel(true)}
      />
      {/* fora da barra de botoes da tela: o dialogo e montado no body */}
      {ReactDOM.createPortal(
        <AgendarRelatorioDialog
          visible={visivel}
          onHide={() => setVisivel(false)}
          relatorio={{ path, descricao: agendavel.descricao }}
          camposData={agendavel.camposData}
          EditorFiltros={agendavel.EditorFiltros}
          filtrosTela={agendavel.filtrosDaTela(record)}
          onSaved={() => mostrarSucesso(textoAgendamento('agendado'))}
        />,
        document.body
      )}
    </React.Fragment>
  )
}

export const AgendarTelaFixa = connect(null, mapDispatchToProps)(AgendarTelaFixaBase)
